module.exports = __webpack_public_path__ + "img/Micronesia.67f27f62.svg";